import axios from 'axios';
import React from 'react';
import { connect } from 'socket.io-client';
import { createLiveStreamingDialogEvent, createRecordingDialogEvent, sendAnalytics } from '../../../analytics';
import { toggleRequestingSubtitles } from '../../../subtitles';
import { FEATURE_CUSTOM_REDUX, FEATURE_CUSTOM_REDUX_V2, FEATURE_CUSTOM_REDUX_V3 } from '../../constant';
import { socketEmit } from '../../../../../socket/index';
import { Constant, CURRENT_ROOM_NAME } from '../../../webjam/constant/index';
import { dispatch, getBaseConfig, getStore, stopRecStream, _ValidateIPaddress } from "../../Utils"
import { RECORDING_TYPES } from '../../../recording/constants';
import { JitsiRecordingConstants } from '../../../base/lib-jitsi-meet';
import { hideNotification, showErrorNotification } from '../../../notifications';
import { PARTICIPANT_ROLE } from '../../../base/participants';
import { sendData } from '../../../webjam/websocket';
import { setCirclePanChange, setIsRecordingLoader, setRecordingModalCount, setRecordingTimer } from '../../redux/tool-webjam-v2/actions';
import Lighting from './Lighting';
import ModalDialog from '@atlaskit/modal-dialog';
import Footer from '../../explore/footer';
import { SaveLog } from '../../../customise/Utils'
import { setLiveStreamingStatus } from '../../redux/tool-webjam-v3/actions';
import { ct } from '../../constant-Utils';

var url = window.location.href.replace(/\/$/, '');

export const StartRecApi = (props, state) => {

    const { uniqueId, usersData, roomorIpAddress, stemRecording } = getStore(FEATURE_CUSTOM_REDUX);
    const _recName = getStore(FEATURE_CUSTOM_REDUX).recIpAddress;
    const { recIpAddress, mp4name, recTimeStamp, withoutName } = props;
    const startRecordingApi = (recIpAddress, recTimeStamp, mp4name) => {
        const { _autoCaptionOnRecord, _conference, _isDropboxEnabled, _token } = props;
        let appData;
        const attributes = {};

        let recIpAddressNew = recIpAddress;

        let isIp = _ValidateIPaddress(roomorIpAddress);
        let url;
        // let url = `${Constant.App.RecordingUrl}/start-recording?mp4name=${mp4name}`;
        let noChangedRoomName = getBaseConfig('noChangedRoomName')
        if (noChangedRoomName == true) {
            recIpAddressNew = roomorIpAddress
            isIp = _ValidateIPaddress(roomorIpAddress);
            url = Constant.App.ServerUrl + '/start-audio-route?isIP=' + isIp + '&roomname=' + roomorIpAddress + '&server=' + getBaseConfig("serverVarRecordingStreaming") + `&name=${roomorIpAddress}&mp4name=${mp4name}&processtype=recording` + `&visibleRoom=${CURRENT_ROOM_NAME}`;
        } else {
            url = Constant.App.ServerUrl + '/start-audio-route?isIP=' + isIp + '&roomname=' + roomorIpAddress + '&server=' + getBaseConfig("serverVarRecordingStreaming") + `&name=${recIpAddress}&mp4name=${mp4name}&processtype=recording`;
        }

        if (!withoutName) {
            url += `&name=${recIpAddressNew}`;
        }
        axios.get(url).then(response => {
            if (!response?.data?.status && response?.data?.type == 1) {
                stopRecStream()

                dispatch(showErrorNotification({
                    titleKey: 'Busy server',
                    descriptionKey: response.data.message
                }));
                //return false;
                //IF SERVER IS BUSY: CALL STOP STEM RECORDING API HERE
                // let url = `${Constant.App.ServerUrl}/stop-stem-recording`;
                // //let url = 'http://localhost:8888/stop-stem-recording';
                // if (usersData) {
                //     const data = {
                //         location: window.location.origin,
                //         roomName: usersData.hostAddress, //usersData.hostedRoom, //lastSeg, //
                //         hostDeviceId: usersData.uniqueId
                //     };

                //     //API hit to stop stem recording
                //     console.log("Busy server usersData-------- ", data);
                //     axios.post(url, data).then(response => {
                //         console.log(" STOP STEM :::::::::::: ", response);
                //     }).catch(error => {
                //         console.log("Invalid STOP Stem :", error);
                //     });
                // }
            } else {
                let obj = {
                    recordingip: recIpAddressNew,
                    recordingkey: recTimeStamp,
                    recordingUniqueID: uniqueId
                };

                setTimeout(() => {
                    if (_isDropboxEnabled && _token && state.selectedRecordingService === RECORDING_TYPES.DROPBOX) {
                        appData = JSON.stringify({
                            'file_recording_metadata': {
                                'upload_credentials': {
                                    'service_name': RECORDING_TYPES.DROPBOX,
                                    'token': _token
                                }
                            }
                        });
                        attributes.type = RECORDING_TYPES.DROPBOX;
                    } else {
                        appData = JSON.stringify({
                            'file_recording_metadata': {
                                'share': state.sharingEnabled
                            }
                        });
                        attributes.type = RECORDING_TYPES.JITSI_REC_SERVICE;
                    }

                    sendAnalytics(
                        createRecordingDialogEvent('start', 'confirm.button', attributes)
                    );

                    _conference.startRecording({
                        mode: JitsiRecordingConstants.mode.FILE,
                        appData
                    });

                    if (_autoCaptionOnRecord) {
                        dispatch(toggleRequestingSubtitles());
                    }
                    return true;
                }, 5000);
                socketEmit("start_recording", obj);
                return true;
            }
        }).catch(error => {
            console.log("Invalid Start Recording :", error);
            return false;
        });
    }

    //CUSTOM:
    if (_ValidateIPaddress(recIpAddress) && usersData) {
        startRecordingApi(recIpAddress, recTimeStamp, mp4name);
        return true;
    } else if (usersData) {
        // Self host
        startRecordingApi(recIpAddress, recTimeStamp, mp4name);
        return true;

        // let url = `${Constant.App.RecordingUrl}/get-ip?roomname=${recIpAddress}`;
        // axios.get(url).then(response => {
        //     console.log(":::::::::::::::::: get-ip", response);
        //     if (response.data.status && response.data.data) {
        //         const ip = response.data.data.ip + ':' + response.data.data.port;
        //         startRecordingApi(ip, recTimeStamp, mp4name);
        //         return true;
        //     }
        // }).catch(error => {
        //     console.log("Invalid get-ip :", error);
        //     return false;
        // });

        // return true;
    } else {
        startRecordingApi(recIpAddress, recTimeStamp, mp4name);
        return true;
    }
}

export const LiveStreamingStart = (props, state) => {
    const { usersData } = props;
    let recIpAddress = CURRENT_ROOM_NAME;

    const startStreamApi = (recIpAddress) => {
        const { broadcasts, selectedBoundStreamID } = state;
        const key
            = (state.streamKey || props._streamKey || '').trim();

        let url = `${Constant.App.StreamingUrl}/start-streaming?name=${recIpAddress}`;
        let url2 = `${Constant.App.StreamingUrl}/started-streaming?name=${recIpAddress}`;

        axios.get(url).then(response => {
            axios.get(url2).then(response2 => {
                console.log(":::::::::::::::::: RRES2 ", response2);
            });
        }).catch(error => {
            console.log("Invalid START streaming :", error);
        });

        setTimeout(() => {
            let selectedBroadcastID = null;
            if (selectedBoundStreamID) {
                const selectedBroadcast = broadcasts && broadcasts.find(
                    broadcast => broadcast.boundStreamID === selectedBoundStreamID);

                selectedBroadcastID = selectedBroadcast && selectedBroadcast.id;
            }

            sendAnalytics(
                createLiveStreamingDialogEvent('start', 'confirm.button'));

            props._conference.startRecording({
                broadcastId: selectedBroadcastID,
                mode: JitsiRecordingConstants.mode.STREAM,
                streamId: key
            });
            //return true;
        }, 5000);
    }

    if (_ValidateIPaddress(recIpAddress) && usersData) {
        startStreamApi(recIpAddress);
        return true;
    } else if (usersData) {
        let url = `${Constant.App.RecordingUrl}/get-ip?roomname=${recIpAddress}`;
        axios.get(url).then(response => {
            if (response.data.status && response.data.data) {
                const ip = response.data.data.ip + ':' + response.data.data.port;
                startStreamApi(ip);
            }
        }).catch(error => {
            console.log("Invalid get-ip :", error);
        });
        return true;
    }
}

export const StartStemRecApi = () => {
    const { userLoginData, usersData, stemRecording, devicesUsers, roomorIpAddress, recTimeStamp, recordingStarted } = getStore(FEATURE_CUSTOM_REDUX);
    const { recordingModalCount } = getStore(FEATURE_CUSTOM_REDUX_V2);

    dispatch(setIsRecordingLoader(false))

    const { local } = getStore('features/base/participants');
    const { iAmRecorder } = getStore('features/base/config');

    if (local.role != PARTICIPANT_ROLE.MODERATOR) { return false }

    if (!recTimeStamp || recTimeStamp == null || recTimeStamp == undefined) return false;

    if (recordingStarted != 1) {
        return false;
    }

    let time = Math.round(new Date().getTime() / 1000);
    dispatch(setRecordingTimer(time))
    dispatch(setRecordingModalCount(0));
    socketEmit("recording_status", {
        roomName: CURRENT_ROOM_NAME,
        location: window.location.origin,
        timestamp: recTimeStamp,
        status: true,
        stemStatus: stemRecording,
        jitsiId: local.id,
        iAmRecorder: iAmRecorder ? 1 : 0,
        type: 1,
        detail: local,
        recordingStarted, // my send should not listen to me (flag)
        recordingTimer: time,
        count: 0
    });

    console.log("stemRecording STart", stemRecording)

    if (stemRecording) {
        let url = `${Constant.App.ServerUrl}/start-stem-recording`;

        if (usersData || devicesUsers) {
            let uniqueId = "";
            let myName = "";
            if (devicesUsers?.uniqueId) {
                uniqueId = devicesUsers.uniqueId;
            } else if (usersData.uniqueId) {
                uniqueId = usersData.uniqueId
            }

            if (devicesUsers?.myName) {
                myName = devicesUsers.myName;
            } else if (usersData?.uniqueId) {
                myName = usersData.myName
            }

            const { authOrganization, recordingEmail } = getStore(FEATURE_CUSTOM_REDUX_V2)
            const data = {
                location: window.location.origin,
                roomName: roomorIpAddress,
                hostDeviceId: uniqueId,
                organization_name: authOrganization.name,
                mod_email: recordingEmail,
                users: {
                    name: local.name ? local.name : myName,
                    jitsiId: local.id,
                    userId: userLoginData?.user?.id,
                }
            };


            //API hit to start stem recording
            axios.post(url, data).then(response => {
                console.log(" START STEM :::::::::::: ", response);
            }).catch(error => {
                console.log("Invalid START Stem :", error);
            });
        }
    }
}


export const StopStemRecApi = (isFailed = '') => {
    const { userLoginData, usersData, stemRecording, devicesUsers, roomorIpAddress, recordingStarted } = getStore(FEATURE_CUSTOM_REDUX);
    const { authOrganization } = getStore(FEATURE_CUSTOM_REDUX_V2);

    dispatch(setIsRecordingLoader(false))
    dispatch(hideNotification("recording.init"))
    dispatch(hideNotification("recording.prepare"))
    dispatch(setRecordingTimer(0))

    socketEmit("recording_stopped", {
        room: CURRENT_ROOM_NAME,
        organization_id: authOrganization._id
    });

    // only stopped user will hit the api
    if (recordingStarted != 2) {
        return false;
    }

    console.log("stemRecordingstemRecording ", stemRecording)
    if (stemRecording) {
        const { local } = getStore('features/base/participants');

        let url = `${Constant.App.ServerUrl}/stop-stem-recording`;

        if (isFailed == "true") {
            // If jitsi recording is failed to start or stopped automatically in between of recording,
            //it will stop the jamulus recording but box will not upload the recording on s3 
            //and also recording url "event" will not received from device
            url = `${Constant.App.ServerUrl}/stopping-stem-recording`;
        }

        console.log("User data ", usersData, " devices ", devicesUsers)

        if (usersData || devicesUsers) {
            let uniqueId = "";
            let myName = "";
            if (devicesUsers?.uniqueId) {
                uniqueId = devicesUsers.uniqueId;
            } else if (usersData.uniqueId) {
                uniqueId = usersData.uniqueId
            }

            if (devicesUsers?.myName) {
                myName = devicesUsers.myName;
            } else if (usersData?.uniqueId) {
                myName = usersData.myName
            }

            const { authOrganization } = getStore(FEATURE_CUSTOM_REDUX_V2)
            const data = {
                location: window.location.origin,
                roomName: roomorIpAddress,
                hostDeviceId: uniqueId,
                organization_name: authOrganization.name,
                users: {
                    name: local.name ? local.name : myName,
                    jitsiId: local.id,
                    userId: userLoginData?.user?.id,
                }
            };

            //API hit to stop stem recording
            axios.post(url, data).then(response => {
                console.log(" stop STEM :::::::::::: 2 ", response);
            }).catch(error => {
                console.log("Invalid stop Stem :", error);
            });
        }
    }
}


export const LightingIcon = (props) => {
    if (props.usersListArray.length > 0) {
        return <>
            <Lighting></Lighting>
        </>
    } else {
        return <>
            <div></div>
        </>
    }
}

export const StarIcon = (props) => {
    const starIcon = getBaseConfig("starIcon");
    if (props.usersListArray.length) {
        return <>
            <div className="box-light"><img className="box-light-img" src={starIcon} /></div>
        </>
    } else {
        return <>
            <div></div>
        </>
    }
}

export const AutoChangeCircleSlider = (value, index = '', where = '') => {
    const { usersData, roomorIpAddress } = getStore(FEATURE_CUSTOM_REDUX);

    dispatch(setCirclePanChange(Math.round(Math.random() * 1000)))

    let jitsiModerator = false;
    if (usersData) {
        if (usersData.hasOwnProperty("users") && usersData?.users?.length) {
            const { users } = usersData;
            let usersLen = users.length;
            let i = 0;
            function sendRequest(usersLen) {
                setTimeout(function () {
                    if (i < usersLen) {
                        i++;
                        let message = {
                            action: {
                                panValue: value,
                                uniqueID: usersData.uniqueId,
                                index: users[i - 1].index,
                                ipAddress: roomorIpAddress,
                                jitsiModerator
                            },
                            content: 'set-pan',
                            isBroadcast: true,
                            sender: 'mobile'
                        };

                        //-------------Prepare logger data -------------
                        var log_data = {
                            functionName: '',
                            triggeredBy: 'system',
                            event: message.content,
                            requestData: message,
                            responseData: '',
                            userId: '',
                            boxId: message.action.uniqueID,
                            message: 'Emit to server'
                        }
                        SaveLog(log_data);
                        //-------------------------------------------

                        sendData(message, 'loading', true)
                        sendRequest(usersLen);
                    }
                }, 1000)
            }
            sendRequest(usersLen)
        }
    }
}

export const DialogModal = (props) => {

    const {
        title,
        isHide,
        onSubmit,
        onClose,
        children,
        submitText,
        testId
    } = props;

    return (<>
        <ModalDialog
            heading={title || "Model Heading"}
            testId={testId ? testId : ''}
            components={{
                Footer: () => <Footer
                    text={submitText || ct("Translate.buttonTitle.submit")}
                    isHide={isHide}
                    className={isHide ? "flex-row-reverse" : ""}
                    onSubmit={onSubmit}
                    onClose={onClose}
                    showKeyline={false} />,
                Container: 'div',
            }}
        >
            {children}
        </ModalDialog>
    </>)

}

export const streamingSocket = (status = false) => {
    return (dispatch, getState) => {

        const {
            roomorIpAddress
        } = getState()[FEATURE_CUSTOM_REDUX]

        const {
            authOrganization
        } = getState()[FEATURE_CUSTOM_REDUX_V2]

        const {
            local
        } = getState()['features/base/participants'];

        dispatch(setLiveStreamingStatus(status,local.id))

        socketEmit('streaming_status', {
            organization_id: authOrganization._id,
            room: roomorIpAddress,
            status,
            jitsiId: local.id,
        });
    }
}